import {AddCircle} from "@mui/icons-material";
import {IconButton, Tooltip} from "@mui/material";
import React from "react";
import keywordSortFields from "../../../model/table/sort/KeywordSortFields";
import TableToolbar from "../../common/table/TableToolbar";
import KeywordFiltersModal from "./CategoriesFiltersModal";
import KeywordFilters from "../../../model/filters/KeywordFilters";
import categorySortFields from "../../../model/table/sort/CategorySortFields";

interface CategoriesTableToolbarProps {
  numSelected: number,
  handleNew: () => void,
  applyFilters: (filters: KeywordFilters) => void
  applySort: (sort: string) => void
}

const CategoriesTableToolbar = ({numSelected, handleNew, applyFilters, applySort}: CategoriesTableToolbarProps) => {

  const [filters, setFilters] = React.useState<KeywordFilters>({});

  const handleConfirm = (newStateFilters: KeywordFilters) => {
    setFilters(newStateFilters);
    applyFilters(newStateFilters);
  }

  const handleClean = () => {
    setFilters({});
    applyFilters({});
  }

  const [openFilterModal, setOpenFilterModal] = React.useState<boolean>(false);
  const handleOpenFilterModal = () => setOpenFilterModal(true);
  const handleCloseFilterModal = () => {
    setOpenFilterModal(false);
  };

  return (
    <>
      <TableToolbar
        numSelected={numSelected}
        title="Categorie"
        fields={categorySortFields}
        filters={Object.values(filters)}
        defaultField={categorySortFields[0].value}
        defaultOrder={'asc'}
        handleOpenFiltersModal={handleOpenFilterModal}
        handleCleanFilters={handleClean}
        handleExport={() => alert('export selection')}
        handleDelete={() => alert('delete selection')}
        handleSort={applySort}
        extendedActions={
          <>
            <Tooltip title="Aggiungi nuova categoria">
              <IconButton color="secondary" onClick={handleNew}>
                <AddCircle />
              </IconButton>
            </Tooltip>
          </>
        }
      />
      <KeywordFiltersModal
        open={openFilterModal}
        filters={filters}
        handleClose={handleCloseFilterModal}
        handleClean={handleClean}
        handleConfirm={handleConfirm}
      />
    </>
  );
}

export default CategoriesTableToolbar;
